import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import Select from "@mui/material/Select";
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import Popover from "@mui/material/Popover";
import { ArrowDropDownRounded } from "@mui/icons-material";

type SelectDateProps = {
  value: Dayjs | null;
  setValue: (value: Dayjs) => void;
};
const SelectDate = ({ value, setValue }: SelectDateProps) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(prev => !prev);
  };

  const canBeOpen = open && Boolean(anchorEl);
  const id = canBeOpen ? "calendar-popper" : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Select
        value=""
        open={false}
        displayEmpty
        onClick={handleClick}
        renderValue={() =>
          value ? value.format("MMM D, YYYY") : "Pick a date"}
        className="!rounded-full w-full max-h-[42px] select-no-outline bg-tgpt-secondary-accentLight text-mui-black-87 dark:!text-white"
        IconComponent={() => (
          <ArrowDropDownRounded className="text-action-active me-2" />
        )}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: {
              marginTop: 1,
            },
          },
        }}
      >

        <CalendarPicker
          minDate={dayjs()}
          date={value}
          onChange={(newDate) => {
            setValue(newDate);
            setOpen(false);
          }}
          className="h-[280px]"
        />
      </Popover>
    </LocalizationProvider>
  );
};

export default SelectDate;
